import { render, staticRenderFns } from "./BaseReportForm.vue?vue&type=template&id=015bc436&scoped=true&"
import script from "./BaseReportForm.vue?vue&type=script&lang=js&"
export * from "./BaseReportForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseReportForm.vue?vue&type=style&index=0&id=015bc436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015bc436",
  null
  
)

export default component.exports